import React from "react";
import styled from "styled-components";

import { Svg } from "./Svg";
import { mdiMagnify } from "@mdi/js";

const SearchStyle = styled.div`
    height: 28px;
    display: flex;
    border-radius: 2px;
    box-sizing: border-box;
    background-color: ${props => props.theme.white};
    border: 1px solid ${props => props.theme.primaryLight};
    &:focus-within {
        border-color: ${props => props.theme.white};
        outline: 1px solid ${props => props.theme.primaryLight};
        >svg {
            outline: 1px solid ${props => props.theme.primaryLight};
        }
    }
    >svg {
        font-size: 13px;
        padding: 5px 6px 5px 8px;
        color: ${props => props.theme.white};
        background-color: ${props => props.theme.primaryLight};
    }
`;

const InputStyle = styled.input`
    width: 120px;
    padding: 4px 10px;
    border-radius: 2px;
    border: 1px solid transparent;
    background-color: ${props => props.theme.white};
`;

export const Search = props => {

    const { id, value, onChange } = props;

    if (!id) {
        throw new Error("Search component requires an id");
    }

    return (
        <SearchStyle>
            <InputStyle
                id={id}
                type="text"
                value={value}
                onChange={event => {
                    const newValue = event.target.value;
                    localStorage.setItem(id, newValue);
                    return onChange(newValue);
                }} />
            <Svg path={mdiMagnify} size="16" />
        </SearchStyle>
    );
};